export default __webpack_public_path__ + "static/media/type_3.90ac5c12.svg";